import { Flex, Text, useTheme } from "@chakra-ui/react";
import React from "react";
import { Theme } from "../theme";

type NodataPropType = {
  heading: string;
};

const Nodata = (props: NodataPropType) => {
  const { heading } = props;
  const theme = useTheme<Theme>();

  return (
    <Flex
      style={{
        width: "50%",
        padding: "2rem",
        marginTop: "2rem",
        borderRadius: "4px",
        border: "1px solid",
        borderColor: theme.colors.divider,
        backgroundColor: "#FFFFFF",
      }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        {heading}
      </Text>
    </Flex>
  );
};

export default Nodata;
